/**
 * Trim trailing slashes from the siteUrl so it meshes with the path.
 * Eg. www.sharesight.com/ + /pricing = www.sharesight.com//pricing
 * Should be: www.sharesight.com/pricing
 */
export function normalizeSiteUrl(siteUrl: string): string {
  return siteUrl.replace(/[/]+$/g, '');
}
